/*
 * Copyright (c) 2017 Payoneer Germany GmbH. All rights reserved.
 */

var rootScope = require('../root-scope.service');
var translate = require('../translate.service');
var localize = require('../localize.service');
var handleServiceError = require('../handle-error.service');

var BUTTONKEYS = {
    PRESET: 'button.operation.PRESET.label',
    CHARGE: 'button.operation.CHARGE.label',
    UPDATE: 'button.operation.UPDATE.label',
    PAYOUT: 'button.operation.PAYOUT.label',
    SAVE: 'button.operation.SAVE.label',
    TOKENIZE: 'button.operation.TOKENIZE.label',
    ACTIVATION: 'button.operation.ACTIVATION.label',
};

/**
 * Get button key by type of operation
 *
 * @param {String} type
 * @returns {String} key of button to use in translation
 */
function getKeyByType(type) {
    var typeKey = type.toUpperCase();
    if (BUTTONKEYS[typeKey]) {
        return BUTTONKEYS[typeKey];
    }

    return BUTTONKEYS.CHARGE;
}
/**
 * Get Generic Button Key
 *
 * @returns {String} button label key, used for translation
 */
function getGenericButtonKey() {
    return getKeyByType(rootScope.getOperationType());
}

/**
 * Get Generic Button Label
 *
 * @returns {String} button label key, used for translation
 */
function getGenericButtonLabel() {
    return translate(getGenericButtonKey());
}

/**
 * Get Button Key From Url
 * @param {String} url
 * @param {String} rollBackKey
 *
 * @returns {String} button key
 */
function getButtonKeyFromUrl(url, rollBackKey) {
    if (url === null) {
        return rollBackKey;
    }
    if (url.endsWith('preset')) {
        return getKeyByType('preset');
    }
    if (url.endsWith('charge')) {
        return getKeyByType('charge');
    }
    if (url.endsWith('update')) {
        return getKeyByType('update');
    }
    if (url.endsWith('payout')) {
        return getKeyByType('payout');
    }
    if (url.endsWith('save')) {
        return getKeyByType('save');
    }
    if (url.endsWith('tokenize')) {
        return getKeyByType('tokenize');
    }
    if (url.endsWith('activate')) {
        return getKeyByType('activation');
    }

    return rollBackKey;
}
/**
 * Get Button Key By Network
 *
 * @param {Object} network
 * @return {String} key of the button label used in translation
 */
function getButtonKeyByNetwork(network) {
    if (network.networkCode === 'preset') {
        return glob.summaryPage ? getKeyByType('charge') : getKeyByType('preset');
    }
    if (network && network.operationType) return getKeyByType(network.operationType);
    var url = null;
    if (network.links && network.links.operation) {
        url = network.links.operation;
    }
    return getButtonKeyFromUrl(url, getGenericButtonKey());
}

function updateSubmitButtonLabel(network) {
    localize.load(network.links.lang, translateSubmitButtonLabel, network);
}

function translateSubmitButtonLabel(err, translation, network) {
    if (err) {
        return handleServiceError(err);
    }

    var key = getButtonKeyByNetwork(network);
    var label = translate(key, translation);

    // if key is not available in the selected network properties file
    //for translation of button, use checkout.properties
    if (label === key || label === '') {
        label = translate(key);
    }
    rootScope.getSubmitButton().html(label);
}

module.exports = {
    getGenericButtonLabel,
    updateSubmitButtonLabel,
    translateSubmitButtonLabel,
    getButtonKeyByNetwork,
    getButtonKeyFromUrl,
    getGenericButtonKey,
    getKeyByType,
};
